import { GROUNDY } from "@/components/onboarding/groundyArt";

/**
 * Groundy waving from the top left edge of the Welcome photo. The body and hand
 * are two layered pictures; only the hand waves. With Reduce Motion on, he
 * simply shows at rest.
 */
export function WelcomeGroundy() {
  return (
    <div
      className="absolute groundy-pop"
      style={{ right: 14, bottom: "calc(100% - 4px)", width: 84 }}
      data-testid="welcome-groundy"
    >
      <div className="relative groundy-bob" style={{ width: 84 }}>
        <img src={GROUNDY.welcomeBody} alt="" aria-hidden="true" className="block w-full h-auto" />
        <img
          src={GROUNDY.welcomeHand}
          alt=""
          aria-hidden="true"
          data-testid="welcome-groundy-hand"
          className="absolute groundy-wave"
          style={{
            left: "68.74%",
            top: "38.42%",
            width: "22.75%",
            height: "27.67%",
            transformOrigin: "26.86% 86.18%",
          }}
        />
      </div>
      <style>{`
        @keyframes groundyPop {
          0% { transform: translateY(40px) scale(0.6); opacity: 0; }
          60% { transform: translateY(-6px) scale(1.04); opacity: 1; }
          100% { transform: translateY(0) scale(1); opacity: 1; }
        }
        @keyframes groundyBob {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-3px); }
        }
        @keyframes groundyWave {
          0% { transform: rotate(0deg); }
          10% { transform: rotate(-13deg); }
          22% { transform: rotate(11deg); }
          34% { transform: rotate(-13deg); }
          46% { transform: rotate(11deg); }
          56% { transform: rotate(-4deg); }
          64%, 100% { transform: rotate(0deg); }
        }
        .groundy-pop { animation: groundyPop 0.65s cubic-bezier(.2,.9,.3,1.25) both; }
        .groundy-bob { animation: groundyBob 2.6s ease-in-out 0.7s infinite; }
        .groundy-wave { animation: groundyWave 3.6s ease-in-out 1.1s infinite; }
        @media (prefers-reduced-motion: reduce) {
          .groundy-pop, .groundy-bob, .groundy-wave { animation: none; }
        }
      `}</style>
    </div>
  );
}
